import { render, staticRenderFns } from "./Tp-check.vue?vue&type=template&id=0d96cb2d&scoped=true"
import script from "./Tp-check.vue?vue&type=script&lang=js"
export * from "./Tp-check.vue?vue&type=script&lang=js"
import style0 from "./Tp-check.vue?vue&type=style&index=0&id=0d96cb2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96cb2d",
  null
  
)

export default component.exports